import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject, Injector } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { tap } from 'rxjs';

const PROJECT_ARCHIVED_CODE = 'PROJECT_ARCHIVED';

function isProjectArchived(error: unknown): boolean {
  return error instanceof HttpErrorResponse && error.status === 403 && error.error?.code === PROJECT_ARCHIVED_CODE;
}

export const projectArchivedInterceptor: HttpInterceptorFn = (req, next) => {
  // Erst im Fehlerfall auflösen: TranslateService lädt seine Übersetzungen schon in seinem Konstruktor
  // über diesen Interceptor, ein frühes inject() bricht dieses Laden ab.
  const injector = inject(Injector);

  return next(req).pipe(
    tap({
      error: (error: unknown) => {
        if (!isProjectArchived(error)) return;
        const snackBar = injector.get(MatSnackBar);
        const translate = injector.get(TranslateService);
        setTimeout(() =>
          snackBar.open(translate.instant('fehler.projektArchiviert'), undefined, { panelClass: 'snackbar-error' }),
        );
      },
    }),
  );
};
